import { useEffect, useState } from "react";
import { api, fmtError, fmtDate } from "../api";
import { useAuth } from "../AuthContext";
import { toast } from "sonner";
import { Lightbulb, Send, Trash2 } from "lucide-react";

export default function Ideenliste() {
  const { user } = useAuth();
  const isAdmin = !!user?.roles?.includes("admin");
  const [ideas, setIdeas] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => {
    api.get("/ideas").then((r) => setIdeas(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    try {
      await api.post("/ideas", { text, author: user?.email || undefined });
      setText("");
      load();
    } catch (err) {
      toast.error(fmtError(err, "Idee konnte nicht gespeichert werden"));
    } finally {
      setBusy(false);
    }
  };

  const remove = async (id) => {
    await api.delete(`/ideas/${id}`).catch((e) => toast.error(fmtError(e)));
    load();
  };

  return (
    <div data-testid="ideas-page">
      <section className="hero-dark slim">
        <span className="badge-hero">Ideenliste</span>
        <h1>Ideen &amp; To-Dos</h1>
        <p className="hero-sub">Sammelstelle für Ideen und offene Punkte – einfach reinschicken.</p>
      </section>

      <div className="container-wd py-8" style={{ maxWidth: 760 }}>
        <form onSubmit={submit} className="card-wd p-5 flex gap-3 items-end mb-6" data-testid="idea-form">
          <label className="field flex-1">
            <span className="field-label">Neue Idee</span>
            <textarea className="input-wd" data-testid="idea-input" rows={2} required
              placeholder="Was soll getestet oder gebaut werden?"
              value={text} onChange={(e) => setText(e.target.value)} />
          </label>
          <button type="submit" className="btn-primary" data-testid="idea-submit" disabled={busy || !text.trim()}>
            <Send size={16} /> Absenden
          </button>
        </form>

        <div className="card-wd" data-testid="ideas-list">
          <div className="p-5 flex items-center gap-2" style={{ borderBottom: "1px solid #E2E8F0" }}>
            <Lightbulb size={18} color="#F97316" />
            <h2 className="font-bold text-sm">{ideas.length} {ideas.length === 1 ? "Eintrag" : "Einträge"}</h2>
          </div>
          {ideas.length === 0 && (
            <p className="p-5 text-sm" style={{ color: "#64748B" }} data-testid="ideas-empty">Noch keine Ideen vorhanden.</p>
          )}
          {ideas.map((idea) => (
            <div key={idea.id} className="p-5 flex gap-3 items-start" style={{ borderBottom: "1px solid #F1F5F9" }}
              data-testid={`idea-item-${idea.id}`}>
              <span className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: "#FFF7ED" }}>
                <Lightbulb size={15} color="#F97316" />
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm m-0" style={{ color: "#0F172A" }}>{idea.text}</p>
                <p className="text-xs mt-1 m-0" style={{ color: "#64748B" }}>
                  {fmtDate(idea.created_at)}{idea.author ? ` · ${idea.author}` : ""}
                </p>
              </div>
              {isAdmin && (
                <button className="btn-secondary" style={{ padding: "6px 10px", color: "#DC2626", borderColor: "#DC2626" }}
                  data-testid={`idea-delete-${idea.id}`} onClick={() => remove(idea.id)} title="Eintrag löschen">
                  <Trash2 size={14} />
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
